import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deCommon from './locales/de/common.json';
import deAuth from './locales/de/auth.json';
import deContent from './locales/de/content.json';
import deRuns from './locales/de/runs.json';
import deAdmin from './locales/de/admin.json';
import deLegal from './locales/de/legal.json';
import deWelcome from './locales/de/welcome.json';
import deEntryChoice from './locales/de/entryChoice.json';
import deProfileSetup from './locales/de/profileSetup.json';
import deOnboarding from './locales/de/onboarding.json';
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enContent from './locales/en/content.json';
import enRuns from './locales/en/runs.json';
import enAdmin from './locales/en/admin.json';
import enLegal from './locales/en/legal.json';
import enWelcome from './locales/en/welcome.json';
import enEntryChoice from './locales/en/entryChoice.json';
import enProfileSetup from './locales/en/profileSetup.json';
import enOnboarding from './locales/en/onboarding.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { common: deCommon, auth: deAuth, content: deContent, runs: deRuns, admin: deAdmin, legal: deLegal, welcome: deWelcome, entryChoice: deEntryChoice, profileSetup: deProfileSetup, onboarding: deOnboarding },
      en: { common: enCommon, auth: enAuth, content: enContent, runs: enRuns, admin: enAdmin, legal: enLegal, welcome: enWelcome, entryChoice: enEntryChoice, profileSetup: enProfileSetup, onboarding: enOnboarding },
    },
    // No hard-coded `lng` — let the LanguageDetector resolve from
    // localStorage → navigator → fallback. This is required so that
    // i18n.changeLanguage(...) calls (spec 025 FR-005) persist across
    // sessions: a hard-coded `lng` would override the detector on every
    // init and reset the user's saved choice.
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'content', 'runs', 'admin', 'legal', 'welcome', 'entryChoice', 'profileSetup', 'onboarding'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'clavis_language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
